<template>
  <div style="height: 100%; overflow: auto">
    <b-card class="sa-card" header="Dettagli Prestazione Presidio" header-tag="header" footer-tag="footer" title="">
      <b-row>
        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
          <label class="sa-label-data">Codice</label>
          <b-form-input v-model="jsonData.codice"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
          <label class="sa-label-data">Descrizione</label>
          <b-form-input v-model="jsonData.descrizione"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
          <label class="sa-label-data">Presidio</label>
          <b-form-select v-model="jsonData.codicePresidio" :options="presidioOptions" value-field="value"
            text-field="text" class="mb-2 mr-sm-2 mb-sm-0"></b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
          <label class="sa-label-data">Branca</label>
          <b-form-select v-model="jsonData.branca" :options="brancaOptions" value-field="codice" text-field="branca"
            class="mb-2 mr-sm-2 mb-sm-0">
            <template #first>
              <b-form-select-option :value="null">- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
          <label class="sa-label-data">Quantità Erogabile</label>
          <b-form-input type="number" v-model="jsonData.quantitaErogabile"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
          <label class="sa-label-data">Prezzo</label>
          <b-form-input type="number" step="0.01" v-model="jsonData.prezzo"></b-form-input>
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
          <label class="sa-label-data d-block">Attivo</label>
          <b-form-checkbox v-model="jsonData.active" switch></b-form-checkbox>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <label class="sa-label-data">Note</label>
          <b-form-textarea v-model="jsonData.note" rows="5"></b-form-textarea>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
  mixins: [UtilityMixin],
  data() {
    return {
      pathResource: "/ricettaprestazionipresidio",
      pathResourcePresidi: "/strutturepresidi",
      pathResourceBranche: "/branche",
      showModalLoading: false,
      id: null,
      jsonData: {
        codice: null,
        descrizione: null,
        quantitaErogabile: null,
        prezzo: null,
        active: true,
        note: null,
        branca: null,
        proprietario: null,
        codicePresidio: null,
      },
      presidioOptions: [],
      listaPresidi: [],
      brancaOptions: [],
    };
  },
  mounted: function () {
    let me = this;
    me.id = this.$route.params.id;
    me.loadData();
    me.loadCodPresidi();
    me.loadBranche();
  },
  watch: {
    jsonData: {
      handler(jsonData) {
        this.$emit("update", jsonData);
      },
      deep: true,
    },
  },
  methods: {
    loadData() {
      let me = this;
      if (me.id === "-1") {
        me.showModalLoading = false;
      } else {
        me.showModalLoading = true;
        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
        axios.get(link + me.id).then((response) => {
          me.jsonData = response.data.data;
          me.showModalLoading = false;
        });
      }
    },
    loadCodPresidi() {
      let me = this;
      me.loadDataResources(me.pathResourcePresidi, { page: 1, forPage: 1000 }, me.resultResponseCodPresidi, me.resultErrorCodPresidi);
    },
    resultResponseCodPresidi(response) {
      let me = this;
      me.presidioOptions = [];
      me.listaPresidi = response.data.data.list;
      me.listaPresidi.forEach((element) => {
        me.presidioOptions.push({
          value: element.codicePresidio,
          text: element.denominazione + " (" + element.codicePresidio + ")",
        });
      });
      me.presidioOptions.unshift({
        value: null,
        text: "-Seleziona Presidio-",
      });
    },
    resultErrorCodPresidi(error) {
      this.messaggeBoxError(this, error);
    },
    loadBranche() {
      let me = this;
      me.loadDataResources(me.pathResourceBranche, {}, me.resultResponseBranche, me.resultErrorBranche);
    },
    resultResponseBranche(response) {
      let me = this;
      me.brancaOptions = response.data.data;
    },
    resultErrorBranche(error) {
      this.messaggeBoxError(this, error);
    },
  },
};
</script>
